import BlokWrap from "@/components/ui/BlokWrap";
import { PATHS } from "@/consts";
import { ArticleRoute } from "@/data/routes/articles.route";
import { ArticlesStoryblok } from "@/generated/sb/sb-types";
import { Link } from "@/i18n/routing";
import formatArticleCard from "@/lib/utils/formatArticleCards";
import { BlokProps, getLink } from "@frend-digital/storyblok";
import ArticleCard from "../../layout/ArticleCategory/components/ArticleCard/ArticleCard";
import styles from "./ArticlesBlok.module.css";

export const ArticlesBlok = ({
  blok,
  data: articles,
  pageOrder,
}: BlokProps<ArticlesStoryblok, ArticleRoute["getManualArticles"]> & {
  pageOrder?: number;
}) => {
  const link = blok?.link?.[0];
  const href = getLink(link?.link)?.href;

  const pattern = [1, 3, 2];
  return (
    <BlokWrap data-layout="page" animated="fadeY" editable={blok}>
      {!blok.title && !link ? null : (
        <div className={styles.head}>
          {blok.title && <h2 className={styles.title}>{blok.title}</h2>}
          {!!link && (
            <Link href={href || PATHS.explore} className={styles.link}>
              {blok.link?.[0]?.text || "See all"}
            </Link>
          )}
        </div>
      )}

      <div className={styles.articleGrid}>
        {articles?.map((article, key) => (
          <ArticleCard
            className={styles.card}
            {...formatArticleCard(article)}
            key={article.full_slug}
            variant={pattern[key]}
            inherit
            pageOrder={pageOrder}
          />
        ))}
      </div>
    </BlokWrap>
  );
};
